// SAFER version
export function mapUserForDisplay(row: any) {
    const firstName = row.name?.trim() || '';
    const lastName = row.lastName?.trim() || '';
    const alreadyHasLastName = firstName.endsWith(' ' + lastName);
    const fullName = lastName && !alreadyHasLastName
      ? `${firstName} ${lastName}`
      : firstName;
    return { id: row.id, name: fullName, firstName, lastName, email: row.email };
  }